"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _hubspot = require("hubspot.bender");

var _hubspot2 = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _Constants = require("FileManagerCore/Constants");

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

function getI18nKey(suffix) {
  return "FileManagerCore.video.termsOfServiceModal." + suffix;
}

function getI18nBodyKey(suffix) {
  return getI18nKey('body') + "." + suffix;
}

var salesItemsI18nKeys = ['sales.item1', 'sales.item2', 'sales.item3'];
var marketingItemsI18nKeys = ['marketing.item1', 'marketing.item2', 'marketing.item3', 'marketing.item4'];

var VidyardTermsOfServiceModal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(VidyardTermsOfServiceModal, _Component);

  function VidyardTermsOfServiceModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, VidyardTermsOfServiceModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(VidyardTermsOfServiceModal).call(this, props));
    _this.state = {
      hideIntegrationChecked: false,
      termsOfServiceStatus: null
    };
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleConfirm = _this.handleConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleHideModal = _this.handleHideModal.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(VidyardTermsOfServiceModal, [{
    key: "handleHideModal",
    value: function handleHideModal(_ref) {
      var checked = _ref.target.checked;
      this.setState({
        hideIntegrationChecked: checked
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var _this$props = this.props,
          trackInteraction = _this$props.trackInteraction,
          updateVidyardTosStatus = _this$props.updateVidyardTosStatus,
          onClose = _this$props.onClose;
      var hideIntegrationChecked = this.state.hideIntegrationChecked;
      trackInteraction(false);

      if (hideIntegrationChecked) {
        this.setState({
          termsOfServiceStatus: _Constants.VidyardTosStatus.HIDDEN
        });
        updateVidyardTosStatus(_Constants.VidyardTosStatus.HIDDEN);
      } else {
        onClose();
      }
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this$props2 = this.props,
          trackInteraction = _this$props2.trackInteraction,
          updateVidyardTosStatus = _this$props2.updateVidyardTosStatus;
      this.setState({
        termsOfServiceStatus: _Constants.VidyardTosStatus.ACCEPTED
      });
      trackInteraction(true);
      updateVidyardTosStatus(_Constants.VidyardTosStatus.ACCEPTED);
    }
  }, {
    key: "getIsSalesUser",
    value: function getIsSalesUser(inferredUserRole) {
      return inferredUserRole === _Constants.UserInferredRoles.get('CRM') || inferredUserRole === _Constants.UserInferredRoles.get('CRM_AND_SALES');
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement("div", {
        className: "m-y-6 text-center"
      }, _react.default.createElement(_UIImage.default, {
        className: "m-right-5",
        responsive: false,
        src: _hubspot.staticDomainPrefix + "/salesImages/static-1.400/logos/hubspot-standard.png",
        width: "150"
      }), _react.default.createElement(_UIIcon.default, {
        name: "plus"
      }), _react.default.createElement(_UIImage.default, {
        className: "m-left-1",
        responsive: false,
        src: _hubspot.staticDomainPrefix + "/FileManagerImages/static-1.3073/images/vidyardLogo.png",
        width: "200"
      }));
    }
  }, {
    key: "renderBulletList",
    value: function renderBulletList(itemsI18nKeys) {
      return _react.default.createElement(_UIList.default, {
        styled: true,
        childClassName: "m-bottom-3 m-top-3"
      }, itemsI18nKeys.map(function (bullet) {
        return _react.default.createElement(_FormattedMessage.default, {
          key: bullet,
          message: getI18nBodyKey("part2." + bullet)
        });
      }));
    }
  }, {
    key: "renderIntegrationsPageMessage",
    value: function renderIntegrationsPageMessage() {
      return _react.default.createElement(_FormattedReactMessage.default, {
        message: getI18nBodyKey('part5'),
        options: {
          integrationsPageLink: _react.default.createElement(_UILink.default, {
            href: "/integrations-settings/" + _hubspot2.default.get() + "/installed/vidyard",
            external: true
          }, _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('integrationsPage')
          }))
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          isLoading = _this$props3.isLoading,
          inferredUserRole = _this$props3.inferredUserRole;
      var _this$state = this.state,
          hideIntegrationChecked = _this$state.hideIntegrationChecked,
          termsOfServiceStatus = _this$state.termsOfServiceStatus;
      return _react.default.createElement(_UIModal.default, {
        width: 650
      }, _react.default.createElement(_UICloseButton.default, {
        onClick: onClose,
        "data-test-id": "close-video-modal"
      }), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h2", null, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('title')
      }))), _react.default.createElement(_UIDialogBody.default, null, this.renderHeader(), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nBodyKey('part1')
      }), this.getIsSalesUser(inferredUserRole) ? this.renderBulletList(salesItemsI18nKeys) : this.renderBulletList(marketingItemsI18nKeys), _react.default.createElement("div", {
        className: "m-all-1"
      }, _react.default.createElement(_FormattedReactMessage.default, {
        message: getI18nBodyKey('part3'),
        options: {
          eulaLink: _react.default.createElement(_UILink.default, {
            href: "https://www.vidyard.com/eula-hubspot/",
            external: true
          }, _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('eula')
          }))
        }
      })), _react.default.createElement("div", {
        className: "m-all-1"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nBodyKey('part4')
      })), _react.default.createElement("div", {
        className: "m-all-1"
      }, this.renderIntegrationsPageMessage())), _react.default.createElement(_UIDialogFooter.default, {
        className: "p-bottom-9"
      }, _react.default.createElement(_UIMedia.default, null, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_UILoadingButton.default, {
        loading: termsOfServiceStatus === _Constants.VidyardTosStatus.ACCEPTED ? isLoading : false,
        disabled: termsOfServiceStatus !== _Constants.VidyardTosStatus.ACCEPTED && isLoading,
        use: "primary",
        onClick: this.handleConfirm,
        "data-test-id": "video-accept-tos"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('confirm')
      })), _react.default.createElement(_UILoadingButton.default, {
        loading: termsOfServiceStatus !== _Constants.VidyardTosStatus.ACCEPTED ? isLoading : false,
        onClick: this.handleCancel,
        disabled: termsOfServiceStatus === _Constants.VidyardTosStatus.ACCEPTED && isLoading
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('decline')
      }))), _react.default.createElement(_UIMediaRight.default, null, _react.default.createElement(_UICheckbox.default, {
        size: "small",
        checked: hideIntegrationChecked,
        onChange: this.handleHideModal
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('dontShowMeAgain')
      }))))));
    }
  }]);
  return VidyardTermsOfServiceModal;
}(_react.Component);

exports.default = VidyardTermsOfServiceModal;
VidyardTermsOfServiceModal.propTypes = {
  onClose: _react.PropTypes.func.isRequired,
  isLoading: _react.PropTypes.bool.isRequired,
  updateVidyardTosStatus: _react.PropTypes.func.isRequired,
  inferredUserRole: _react.PropTypes.string.isRequired,
  trackInteraction: _react.PropTypes.func.isRequired
};
module.exports = exports.default;